import { getEventBus } from '@unisporkal/federation';
import {
  cartContainsAssets,
  addAsset,
  removeAsset,
} from 'app/services/cartService';
import {
  CART_GET_ASSETS,
  CART_ADD_ASSET,
  CART_REMOVE_ASSET,
} from 'app/actions/types';

export const cartGetAssets = (assetIds) => async (dispatch) => {
  const response = await cartContainsAssets(assetIds);
  dispatch({
    type: CART_GET_ASSETS,
    payload: response,
  });
};

export const cartAddAsset = (asset) => async (dispatch) => {
  const response = await addAsset(asset.id);
  dispatch({
    type: CART_ADD_ASSET,
    payload: response,
  });
  getEventBus().triggerAllWindows('addToFancyCart');
};

export const cartRemoveAsset = (asset) => async (dispatch) => {
  const response = await removeAsset(asset.id);
  dispatch({
    type: CART_REMOVE_ASSET,
    payload: response,
  });
  getEventBus().triggerAllWindows('removeFromFancyCart');
};
